import { Component, Input } from '@angular/core';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: '[data-component="validation-messages"]',
  templateUrl: './validation-messages.component.html',
})
export class ValidationMessagesComponent {
  @Input() screenreaderErrorMessages: string = null;
  @Input() errors: Array<any> = null;
  @Input() renderScreenreaderErrors: boolean = true;
  @Input() renderValidationSummary: boolean = true;

  constructor(public utilityService: UtilityService) {}

  public hasScreenreaderErrorMessages(): boolean {
    return (
      this.utilityService.isDefinedAndNotNull(this.screenreaderErrorMessages) &&
      this.screenreaderErrorMessages !== ''
    );
  }

  public hasErrors(): boolean {
    return (
      this.utilityService.isDefinedAndNotNull(this.errors) &&
      this.errors.length > 0
    );
  }
}
